// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gamepad"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 4H21L22 20H17L16 17H8L7 20H2L3 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 4H21L22 20H17L16 17H8L7 20H2L3 4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 10.5L8 10.5M8 10.5L6 10.5M8 10.5V8.5M8 10.5L8 12.5M17 8.5H17.0039V8.50391H17V8.5ZM17 12.4961H17.0039V12.5H17V12.4961Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GamepadIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gamepad',
    ref,
    icon: element,
  },
));

GamepadIcon.displayName = 'GamepadIcon';

export default GamepadIcon;
